module.exports = __webpack_public_path__ + "static/img/banner.6a39b00b.png";